import React, { useState } from "react";
import { IBrand } from "../../models/brand.ts";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

interface BrandSelectProps {
  brands: IBrand[];
  onSelectedBrandChange: (selectedBrand: IBrand) => void;
}

export const BrandSelect: React.FC<BrandSelectProps> = ({
  brands,
  onSelectedBrandChange,
}) => {
  const [selectedBrand, setSelectedBrand] = useState<string>("0");
  if (brands && brands.length > 0) {
    return (
      <FormControl fullWidth variant="outlined">
        <InputLabel>ブランド</InputLabel>
        <Select
          value={selectedBrand}
          onChange={(event) => {
            const index = parseInt(event.target.value as string);
            onSelectedBrandChange(brands[index]);
            setSelectedBrand(event.target.value);
          }}
          label="ブランド"
        >
          {brands.map((brand, index) => (
            <MenuItem key={brand.id} value={index}>
              {brand.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
};
